import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaClock,
  FaWhatsapp,
  FaMedal,
  FaShieldAlt,
  FaRunning,
  FaInstagram,
} from "react-icons/fa";
import JAIVEER from "../../assets/photos/jaiveer.jpg";

const Contact = () => {
  return (
    <section className="pt-24 pb-16 bg-slate-950 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-blue-400 font-semibold text-sm uppercase tracking-wider mb-3">
            Contact
          </p>
          <h1 className="text-3xl md:text-5xl font-black text-white mb-4">
            Get in Touch
          </h1>
          <p className="text-slate-400">
            Have questions? Want to visit? Reach out to us — we'd love to hear
            from you.
          </p>
        </div>

        {/* Contact Info + Form */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Contact Details */}
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-10">
            <h2 className="text-xl font-bold text-white mb-8">
              Flipcity Gymnastics Academy
            </h2>
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-blue-400 flex-shrink-0">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <p className="font-semibold text-white text-sm">Address</p>
                  <p className="text-sm text-slate-400">
                    IMT Rd, near Jotram Chowk, Hayatpur,
                    <br />
                    Sector 93, Gurugram, Haryana 122505
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-blue-400 flex-shrink-0">
                  <FaPhone />
                </div>
                <div>
                  <p className="font-semibold text-white text-sm">Phone</p>
                  <a
                    href="tel:+919582691655"
                    className="text-sm text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    +91 95826 91655
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-blue-400 flex-shrink-0">
                  <FaClock />
                </div>
                <div>
                  <p className="font-semibold text-white text-sm">Timings</p>
                  <p className="text-sm text-slate-400">
                    Mon – Sat: 6:00 AM – 9:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* Quick action buttons */}
            <div className="flex flex-wrap gap-3">
              <a
                href="tel:+919582691655"
                className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-bold text-sm px-5 py-3 rounded-full transition-colors"
              >
                <FaPhone className="text-xs" />
                Call Now
              </a>
              <a
                href="https://wa.me/919582691655?text=Hi%2C%20I%20have%20a%20question%20about%20Flipcity%20Gymnastics"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-bold text-sm px-5 py-3 rounded-full transition-colors"
              >
                <FaWhatsapp />
                WhatsApp
              </a>
              <a
                href="https://maps.google.com/?q=Flipcity+Gymnastics+Academy+Sector+93+Gurgaon"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white/5 text-white hover:bg-white/10 font-bold text-sm px-5 py-3 rounded-full transition-colors border border-white/10"
              >
                <FaMapMarkerAlt className="text-xs" />
                Directions
              </a>
            </div>

            {/* Social */}
            <div className="mt-8 pt-6 border-t border-slate-800">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-3">Follow Us</p>
              <a
                href="https://www.instagram.com/flipcitygymnastic/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-slate-400 hover:text-white text-sm transition-colors"
              >
                <FaInstagram />
                @flipcitygymnastic
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-10">
            <h3 className="text-lg font-bold text-white mb-6">
              Send us a message
            </h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                const name = formData.get("fullName");
                const message = formData.get("message");
                window.open(
                  `https://wa.me/919582691655?text=${encodeURIComponent(
                    `Hi, I'm ${name}. ${message}`
                  )}`,
                  "_blank"
                );
              }}
              className="space-y-5"
            >
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1.5">
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-slate-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm bg-slate-800 text-white placeholder-slate-500"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1.5">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-slate-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm bg-slate-800 text-white placeholder-slate-500"
                  placeholder="Your phone number"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1.5">
                  Message
                </label>
                <textarea
                  name="message"
                  rows="4"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-slate-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm bg-slate-800 text-white placeholder-slate-500 resize-none"
                  placeholder="How can we help you?"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-primary-600 hover:bg-primary-700 text-white font-bold py-3.5 rounded-xl transition-colors text-sm"
              >
                Send via WhatsApp
              </button>
            </form>
          </div>
        </div>

        {/* Map */}
        <div className="rounded-2xl overflow-hidden border border-slate-800 mb-16">
          <iframe
            title="Flipcity Gymnastics Academy Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.5!2d76.9315259!3d28.4185384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d177e1ff7cb99%3A0xdfd6767b9ac0defd!2sFlipcity%20Gymnastics%20Academy!5e0!3m2!1sen!2sin!4v1709900000000"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          />
        </div>

        {/* Founder Card */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden">
          <div className="grid md:grid-cols-3">
            <div className="h-64 md:h-auto">
              <img
                src={JAIVEER}
                alt="Jaiveer Yadav — Founder & Head Coach"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="md:col-span-2 p-8 md:p-10 flex flex-col justify-center">
              <p className="text-blue-400 font-semibold text-sm uppercase tracking-wider mb-2">
                Founder & Head Coach
              </p>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-4">
                Jaiveer Yadav
              </h2>
              <div className="flex flex-wrap gap-3 mb-6">
                {[
                  { icon: <FaMedal />, text: "NIS Patiala Diploma" },
                  { icon: <FaShieldAlt />, text: "17 Yrs Indian Army" },
                  { icon: <FaRunning />, text: "Physical Conditioner" },
                  { icon: <FaMedal />, text: "25+ Years Experience" },
                ].map((c, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2"
                  >
                    <span className="text-blue-400 text-sm">{c.icon}</span>
                    <span className="text-xs font-medium text-slate-300">
                      {c.text}
                    </span>
                  </div>
                ))}
              </div>
              <a
                href="https://wa.me/919582691655?text=Hi%2C%20I%27d%20like%20to%20book%20a%20session%20with%20Coach%20Jaiveer"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-bold text-sm px-6 py-3 rounded-full transition-colors w-fit"
              >
                <FaWhatsapp />
                Book a Session
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
